export enum ReportType {
  CherryPay_CardStatus = "cherry-pay-card-status",
  CherryPay_CardProgramType = "cherry-pay-card-program-type",
  CherryPay_CardFundsLoaded = "cherry-pay-card-funds-loaded",
  CherryPass_Downloaded = "cherry-pass-downloaded",
  CherryPlay_PromotionLeaderboardPlayers = "cherry-play/promotion-leaderboard-players",
  CherryPlay_PromotionLeaderboard = "cherry-play/promotion-leaderboard",
  CherryPlay_PromotionRewardDetail = "cherry-play/promotion-reward-detail",
  CherryPlay_PromotionCouponSummary = "cherry-play/promotion-coupon-summary",
}
